import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { Observable } from 'rxjs';
import { BackendResponse, HttpService } from 'vas-mobile-api';

import { Picture } from '../models/delivery';

declare let $: any;

@Component({
  selector: 'app-picture-viewer',
  templateUrl: './picture-viewer.component.html',
  styleUrls: ['./picture-viewer.component.css']
})
export class PictureViewerComponent implements OnInit {

  public pictureNames: string[] = [];
  public ready = false;
  public loadingPicture = false;
  private idx = 0;
  private pictures: Map<number, Picture> = new Map<number, Picture>();


  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { lieferNr: string },
    private httpService: HttpService) { }

  ngOnInit() {

    this.httpService.get<BackendResponse<string[]>>({
      pathId: 'getDeliveryPictureNames', urlParams:
        { liefer_nr: this.data.lieferNr }
    }).subscribe((result) => {
      this.pictureNames = result.data;
      if (this.pictureNames.length > 0) {
        // load first image
        this.loadImage(this.pictureNames[0]).subscribe((imgResult) => {
          this.pictures.set(0, imgResult.data);
          this.ready = true;
        }, (e) => {
          this.ready = true;
        });
      } else {
        this.ready = true;
      }
    }, (e) => {
      this.ready = true;
    });

  }

  public prev() {
    this.idx = Math.max(this.idx - 1, 0);
    this.jumpTo(this.idx);
  }

  public next() {
    this.idx = Math.min(this.idx + 1, this.pictureNames.length - 1);
    this.jumpTo(this.idx);
  }

  public jumpTo(idx: number) {
    if (this.pictureNames.length > 0) {
      this.idx = idx;
      if (!this.pictures.has(this.idx)) {
        this.loadingPicture = true;
        this.loadImage(this.pictureNames[this.idx]).subscribe((result) => {
          this.pictures.set(this.idx, result.data);
          this.loadingPicture = false;
        }, (e) => {
          this.loadingPicture = false;
        });
      }
    }
  }

  public getImageByIndex(idx: number) {
    return this.pictures.get(idx);
  }

  private loadImage(imageName: string): Observable<BackendResponse<Picture>> {
    return this.httpService.get<BackendResponse<Picture>>({ pathId: 'getDeliveryPictureByName', urlParams: { fileName: imageName } });
  }

}
